<template>
  <section class="home">
    <!-- <qx-header-box :noIcon="true" :showLeft="true" :theme="$route.meta.theme" /> -->
    <div class="intro">
      <img src="~images/enterIntro.png" />
    </div>
    <div class="content posire">
      <p class="welcome">
        欢迎您，<span class="primary">{{uname}}，</span>请选择公司
      </p>
      <div class="clearPa companyList">
        <div
          class="item boxShadow left cur"
          v-for="item in companyList"
          :key="item.tenantId"
          @click="handleChoose(item)"
        >
          <p class="imgBox">
            <img src="~images/carLogo.png" />
          </p>
          <p class="companyName">{{item.tenantName}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  getCarList,
  chooseCar,
} from 'api/user';
import Cookies from 'js-cookie';
import DEFAULT_HOME_PATH from '@/router/defaultHome';

const normalizeTenantItems = (res) => {
  if (Array.isArray(res)) {
    return res;
  }
  if (!res) {
    return [];
  }
  if (Array.isArray(res.items)) {
    return res.items;
  }
  if (Array.isArray(res.data)) {
    return res.data;
  }
  if (res.data && Array.isArray(res.data.items)) {
    return res.data.items;
  }
  if (res.content && Array.isArray(res.content.items)) {
    return res.content.items;
  }
  if (res.result && Array.isArray(res.result.items)) {
    return res.result.items;
  }
  return [];
};

export default {
  data () {
    return {
      uname: decodeURIComponent(Cookies.get('userName')),
      companyList: [],
    };
  },
  methods: {
    async handleChoose (item) {
      const res = await chooseCar(item);
      if (!res.failed) {
        this.$router.push(DEFAULT_HOME_PATH);
      }
    },
  },
  async created () {
    const res = await getCarList();
    if (res && !res.failed) {
      const items = normalizeTenantItems(res);
      this.companyList = items.map((item) => ({
        tenantName: item.name,
        tenantId: item.tenantId,
        tenantCode: item.tenantCode,
        referer: DEFAULT_HOME_PATH,
      }));
    }
  },
};
</script>

<style scoped lang="scss">
.intro{
  img{
    width: 100%;
  }
}
.content{
  width: 1200px;
  margin: -72px auto 24px;
  background: #fff;
  border-radius: 16px;
  .welcome{
    text-align: center;
    padding-top: 48px;
    font-size: 24px;
    line-height: 24px;
    height: 24px;
    margin-bottom: 48px;
  }
  .companyList{
    padding: 0 18px 22px;
    .item{
      width: 196px;
      height: 248px;
      box-sizing: border-box;
      border-radius: 8px;
      margin: 0 18px 36px;
      .imgBox{
        text-align: center;
        padding-top: 32px;
        margin-bottom: 48px;
        img{
          width: 96px;
        }
      }
      .companyName{
        text-align: center;
        color: #666;
        font-size: 14px;
        height: 14px;
        line-height: 14px;
      }
    }
  }
}
</style>
